import type { FC } from 'react';

import { usePrevious } from '../../../../../hooks/usePrevious';
import { L10nText } from '../../../../../services/uiTranslations/reactBindings/L10nText';
import { useModifiers } from '../../../../../styles/hooks/useModifiers';
import { NumberSlider } from '../../../../numberSlider/NumberSlider';
import stopIcon from '../../assets/stopIcon.svg';
import type { AutoplayButtonProps } from '../../buttons/base/AutoplayButton';
import { AutoplayButton } from '../../buttons/base/AutoplayButton';
import { ProgressBar } from '../../progressBar/ProgressBar';

import styles from './AutoplayStopButton.module.css';

export interface AutoplayStopButtonProps extends AutoplayButtonProps {
  count: number;
  totalRounds: number;
}

export const AutoplayStopButton: FC<AutoplayStopButtonProps> = ({ count, totalRounds, className, ...rest }) => {
  const mods = useModifiers(styles, 'autoplayStopBtn', {}, { withBaseClass: true, extraClassName: className });
  const prevCount = usePrevious(count) ?? count;

  return (
    <AutoplayButton className={mods} {...rest}>
      <div className={styles.autoplayStopBtn__content}>
        <div className={styles.autoplayStopBtn__roundInfo}>
          <NumberSlider className={styles.autoplayStopBtn__roundsLeft} from={prevCount} to={count} duration={450} />
          {totalRounds ? (
            <span className={styles.autoplayStopBtn__totalRound}>
              {' / '}
              {totalRounds} <L10nText tk="ROUNDS" />
            </span>
          ) : null}
        </div>
        {totalRounds > 0 ? <img className={styles.autoplayStopBtn__icon} src={stopIcon} alt="stop-icon" /> : null}
      </div>
      <ProgressBar max={totalRounds} value={count} />
    </AutoplayButton>
  );
};
